import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { IoClose } from 'react-icons/io5';

import './MyWorks.css'

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000"
const API_URL = window._env_?.API_URL || "http://localhost:5000";

function MyWorks({ pic }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    // Fermer avec la touche Escape
    const handleKeyDown = (e) => {
        if (e.key === 'Escape') closeModal();
    };

    return (
        <div className="my-works-container">
            {/* Image cliquable pour agrandir */}
            <div className="myworks-item-img" onClick={openModal}>
                <img
                    className="works-img"
                    src={`${API_URL}/api/images/${pic.shoe_img}`}
                    alt={pic.shoe_name}
                />
            </div>

            {/* Modal pour l'image agrandie */}
            {isModalOpen && (
                <div 
                    className="modal-overlay" 
                    onClick={closeModal}
                    onKeyDown={handleKeyDown}
                    role="dialog"
                    aria-modal="true"
                    tabIndex={-1}
                >
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button 
                            className="modal-close-btn" 
                            onClick={closeModal}
                            aria-label="Fermer"
                        >
                            <IoClose />
                        </button>
                        <img
                            className="modal-img"
                            src={`${API_URL}/api/images/${pic.shoe_img}`}
                            alt={pic.shoe_name}
                        />
                    </div>
                </div>
            )}

            <div className="myworks-item-info">
                <Link to="#">
                    <h3 className="myworks-item-brand">{pic.shoe_brand}</h3>
                    <h4 className="myworks-item-title">{pic.shoe_name}</h4>
                </Link>
                    <p className="myworks-item-p">Photographer: {pic.photographer}</p>
                    <p className="myworks-item-m">Model: {pic.model}</p>
            </div>
        </div>
    )
}

MyWorks.propTypes = {
    pic: PropTypes.shape({
        shoe_img: PropTypes.string,
        shoe_brand: PropTypes.string,
        shoe_name: PropTypes.string,
        photographer: PropTypes.string,
        model: PropTypes.string
    }).isRequired
};

export default MyWorks
